import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import PrivateRoutes from "./privateRoutes";
import Login from "./pages/auth/login";
import "./assets/styles/styles.scss";
import { FORGOT_PASSWORD, LOGIN, NEW_PASSWORD } from "./constants/routers";
import ForgotPassword from "./pages/auth/forgotPassword";
import NewPassword from "./pages/auth/newPassword";
import { useContext, useEffect, useState } from "react";
import { onMessage, getToken, isSupported } from "firebase/messaging";
import PushNotification from "./components/common/Common/PushNotification";
import { SelectionContext } from "./Context/Store";
import { createUser, updateFCM } from "./api/actions/user";
import { notificationcount } from "./api/actions/notification";
import { clearPendingRequests, getPendingRequests } from "./indexdb/indexdb";
import { createCategory } from "./api/actions/category";
import { createMaterial } from "./api/actions/material";
import { createObject, objectConservationCreation } from "./api/actions/object";
import { createMuseum } from "./api/actions/museum";
import { createRole } from "./api/actions/role";
import { createGroup } from "./api/actions/group";
import { createBuilding } from "./api/actions/building";
import { createStorageType } from "./api/actions/storageType";
import { createUnitType } from "./api/actions/unitType";
import { GlobalLoadProvider } from "./store/globalLoad";
import { useSaving } from "./store/SavinContext";
import {
  clearAutoSavedFromIndexedDB,
  getAutoSavedFromIndexedDB,
} from "./indexdb/autosaveIndex";
import axiosInstance from "./api/axiosInstance";
import { MenuProvider } from "./store/menuContext";
import { useS3context } from "./store/s3Context";
import { messaging } from "./firebase";
import { GlobalreleaseProvider } from "./store/releaseNoteContext";
import { GlobalIsReadProvider } from "./store/globalIsreadContext";
import { ObjectEditProvider } from "./store/objectEditdataContext";

function App() {
  const [notification, setNotification] = useState("");
  const [initials, setInitials] = useState("");
  const { setUpdateCount, setUpdateNotification } =
    useContext(SelectionContext);
  // const messaging = getMessaging();
  const VALID_MODULES = [
    "material",
    "category",
    "collection",
    "conservation",
    "digital",
    "museum",
    "system",
    "unit",
    "location",
    "user",
    "group",
    "role",
  ];
  const online = navigator.onLine;
  const { isSaving } = useSaving();
  const { s3loading } = useS3context();
  const userData = JSON.parse(localStorage.getItem("user_info"));

  const getCount = () => {
    notificationcount({
      museum_id: userData?.museum ? userData?.museum : "",
      is_readed: "False",
    })((response) => {
      if (response?.status) {
        setUpdateNotification((prev) => !prev);
        setUpdateCount({
          all: response?.data?.all,
          mention: response?.data?.mention,
        });
      }
      // setUpdate(!update)
    });
  };

  useEffect(() => {
    if (online) {
      const syncDataWithServer = async () => {
        for (const module of VALID_MODULES) {
          try {
            const pendingRequests = await getPendingRequests(module);

            if (pendingRequests?.length > 0) {
              pendingRequests.map((request) => {
                switch (module) {
                  case "category":
                    return createCategory({ values: request })((response) => {
                      if (response?.status) {
                        toast.success("Category succesfully uploaded");
                      }
                    });
                  case "material":
                    return createMaterial({ values: request })((response) => {
                      if (response?.status) {
                        toast.success("Material succesfully uploaded");
                      }
                    });
                  case "collection":
                    return createObject(request)((response) => {
                      if (response?.status) {
                        toast.success("Object succesfully uploaded");
                      }
                    });
                  case "conservation":
                    return objectConservationCreation(request)((response) => {
                      if (response?.status) {
                        toast.success("Object succesfully uploaded");
                      }
                    });
                  case "digital":
                    return createObject(request)((response) => {
                      if (response?.status) {
                        toast.success("Object succesfully uploaded");
                      }
                    });
                  case "museum":
                    return createMuseum({ values: request })((response) => {
                      if (response?.status) {
                        toast.success("Museum succesfully uploaded");
                      }
                    });
                  case "system":
                    return createStorageType(request)((response) => {
                      if (response?.status) {
                        toast.success("System type succesfully uploaded");
                      }
                    });
                  case "unit":
                    return createUnitType(request)((response) => {
                      if (response?.status) {
                        toast.success("Unit type succesfully uploaded");
                      }
                    });
                  case "location":
                    return createBuilding(request)((response) => {
                      if (response?.status) {
                        toast.success("Location succesfully uploaded");
                      }
                    });
                  case "user":
                    return createUser({ values: request })((response) => {
                      if (response?.status) {
                        toast.success("User succesfully uploaded");
                      }
                    });
                  case "group":
                    return createGroup(request)((response) => {
                      if (response?.status) {
                        toast.success("Group succesfully uploaded");
                      }
                    });
                  case "role":
                    return createRole(request)((response) => {
                      if (response?.status) {
                        toast.success("Role succesfully uploaded");
                      }
                    });

                  default:
                    throw new Error(
                      `API call not defined for module: ${module}`
                    );
                }
              });
            }

            await clearPendingRequests(module);
          } catch (error) {
            console.error(`Error syncing data for ${module}:`, error);
            // Optionally break or continue based on your error-handling logic
            toast.error(`Failed to sync ${module}`);
          }
        }
      };

      syncDataWithServer();
    }
  }, [online]);

  useEffect(() => {
    let messageHandler;

    (async () => {
      const supported = await isSupported();
      if (!supported) {
        console.warn("Skipping Firebase Messaging — not supported here.");
        return;
      }

      if (!("Notification" in window)) {
        console.warn("This browser does not support notifications.");
        return;
      }

      // ✅ Register service worker
      if ("serviceWorker" in navigator) {
        try {
          const registration = await navigator.serviceWorker.register(
            "/firebase-messaging-sw.js"
          );
        } catch (error) {
          console.error("Service Worker registration failed:", error);
        }

        // ✅ Add message listener with cleanup
        messageHandler = (event) => {
          if (event.data && event.data.type === "NEW_NOTIFICATION") {
            const { title, body, icon } = event.data;
            setNotification({ title, body, icon });
            getCount();
          }
        };
        navigator.serviceWorker.addEventListener("message", messageHandler);
      }

      // ✅ Request notification permission
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        onMessage(messaging, (payload) => {
          console.log("payload", payload);
          const { title, body } = payload.notification;
          setNotification({ title, body });
          setUpdateCount((prevCount) => prevCount + 1);
          getCount();
        });
      } else {
        console.error("Unable to get permission to notify.");
      }
    })();

    // ✅ Cleanup message listener on unmount
    return () => {
      if ("serviceWorker" in navigator && messageHandler) {
        navigator.serviceWorker.removeEventListener("message", messageHandler);
      }
    };
  }, []);

  let notificationToken = null;

  const onResponse = (error, token) => {
    if (error) {
      // toast.error(error);
    } else {
      notificationToken = token;

      const logged = localStorage.getItem("is_logged");
      if (logged) {
        localStorage.setItem("FCM_token", notificationToken);
        updateFCM({ fcm_token: token })((response) => {
          if (response?.status) {
          } else {
            toast.error(response?.message);
          }
        });
      }
    }
  };

  const requestForToken = async () => {
    try {
      const supported = await isSupported();
      if (!supported) {
        console.warn("This browser doesn't support Firebase Messaging.");
        return;
      }
      if (!("Notification" in window)) {
        console.warn("Notifications are not supported on this device/browser.");
        return;
      }

      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const token = await getToken(messaging, {
          vapidKey: process.env.REACT_APP_VAPID_KEY,
        });
        if (token) {
          onResponse(null, token);
        } else {
          console.log(
            "No registration token available. Request permission to generate one."
          );
        }
      }
    } catch (error) {
      console.error("Error while fetching FCM token:", error);
    }
  };
  useEffect(() => {
    let interval;
    if (initials) {
      interval = setInterval(() => {
        requestForToken();
      }, 5 * 60 * 1000);
    } else {
      setInitials(true);
      requestForToken();
    }

    return () => clearInterval(interval);
  }, [initials]);

  const handleCloseNotification = () => {
    setNotification(null);
  };
  // console.log("Notif:", notification);

  useEffect(() => {
    const handleUnload = async (event) => {
      const navEntry = performance.getEntriesByType("navigation")[0];

      // If the navigation is a refresh, do NOT call API
      if (navEntry?.type === "reload") {
        await clearAutoSavedFromIndexedDB("digital");
        await clearAutoSavedFromIndexedDB("conservation");
        await clearAutoSavedFromIndexedDB("collection");
        return;
      }
      const saveDataOnClose = async () => {
        const storedData = await getAutoSavedFromIndexedDB("collection");
        const storedDigital = await getAutoSavedFromIndexedDB("digital");
        const storedConservation = await getAutoSavedFromIndexedDB(
          "conservation"
        );
        const sendData = (data, url) => {
          if (data) {
            const blob = new Blob([data], { type: "application/json" });
            navigator.sendBeacon(url, blob);
            console.log(`Data sent to: ${url}`);
          }
        };

        if (storedData) {
          const parsedCollection = storedData;
          parsedCollection.collection_is_draft = true;

          if (parsedCollection.attribute === null)
            delete parsedCollection.attribute;
          if (parsedCollection.category === "")
            delete parsedCollection.category;
          if (parsedCollection.original_location_room === "")
            delete parsedCollection.original_location_room;
          if (!parsedCollection.acquisition_method)
            delete parsedCollection.acquisition_method;

          if (parsedCollection?.transitlunitType) {
            parsedCollection.transit_location_storage_unit =
              parsedCollection.transitlunitType;
          } else if (parsedCollection?.transitlsystemtype) {
            parsedCollection.transit_location_storage_system =
              parsedCollection.transitlsystemtype;
          } else if (parsedCollection?.transitlRoom) {
            parsedCollection.transit_location_room =
              parsedCollection.transitlRoom;
          }

          if (parsedCollection?.originalunitType) {
            parsedCollection.original_location_storage_unit =
              parsedCollection?.originalunitType;
          } else if (parsedCollection?.originalsystemtype) {
            parsedCollection.original_location_storage_system =
              parsedCollection?.originalsystemtype;
          } else if (parsedCollection?.originalRoom) {
            parsedCollection.original_location_room =
              parsedCollection?.originalRoom;
          }

          sendData(
            parsedCollection,
            `${axiosInstance.defaults.baseURL}/museumobject/object/create-or-update-object`
          );
          if (parsedCollection?.assignValue) {
            sendData(
              parsedCollection?.assignValue,
              `${axiosInstance.defaults.baseURL}/museumobject/object/assign-object`
            );
          }
          await clearAutoSavedFromIndexedDB("collection");
        } else if (storedDigital) {
          const parsedDigital = storedDigital;
          if (parsedDigital?.acquisition_method === "") {
            delete parsedDigital?.acquisition_method;
          }

          if (parsedDigital.images) {
            parsedDigital.images = parsedDigital.images.filter(
              (image) => image.images !== ""
            );
          }

          delete parsedDigital.tags;
          delete parsedDigital.dimensions;
          delete parsedDigital.function_or_usages;
          sendData(
            parsedDigital,
            `${axiosInstance.defaults.baseURL}/museumobject/object/create-or-update-object`
          );
          if (parsedDigital?.assignValue) {
            sendData(
              parsedDigital?.assignValue,
              `${axiosInstance.defaults.baseURL}/museumobject/object/assign-object`
            );
          }
          await clearAutoSavedFromIndexedDB("digital");
        } else if (storedConservation) {
          const parsedConservation = storedConservation;
          const filteredProposedTreatment =
            parsedConservation?.proposed_treatment.filter((li) => {
              const noDataPropose =
                li?.step &&
                li?.action === "" &&
                li?.is_completed === false &&
                li?.task === "" &&
                li?.status === "";

              return !noDataPropose;
            });

          const filteredInvestigationTreatment =
            parsedConservation?.investigation_details?.filter((li) => {
              const noInvestigation =
                (li?.invasive_or_non_vasive === false ||
                  li?.invasive_or_non_vasive === true) &&
                li?.result === "" &&
                li?.sample_details === "";

              return !noInvestigation;
            });

          parsedConservation.investigation_details =
            filteredInvestigationTreatment;
          parsedConservation.proposed_treatment = filteredProposedTreatment;
          parsedConservation.conservation_is_draft = true;

          const hasProposedTreatmentWithoutStep =
            parsedConservation?.proposed_treatment?.some((treatment) =>
              ["Started", "In progress", "Done"].includes(treatment.status)
            );

          const conservationStatus = hasProposedTreatmentWithoutStep
            ? "in_conservation"
            : "in_conditional_assessment";

          const statusValues = {
            id: parsedConservation.id,
            conservation_status: conservationStatus,
          };
          sendData(
            parsedConservation,
            `${axiosInstance.defaults.baseURL}/museumobject/object_conservation/create-or-update-object-conservation`
          );
          sendData(
            statusValues,
            `${axiosInstance.defaults.baseURL}/museumobject/object_conservation/change-conservation-status`
          );
          if (parsedConservation?.assignValue) {
            sendData(
              parsedConservation?.assignValue,
              `${axiosInstance.defaults.baseURL}/museumobject/object/assign-object`
            );
          }
          await clearAutoSavedFromIndexedDB("conservation");
        }
      };
      // If page is being closed (tab close, browser close)
      if (document.visibilityState === "hidden") {
        await saveDataOnClose(); // your existing logic
      }
    };

    window.addEventListener("beforeunload", handleUnload);
    document.addEventListener("visibilitychange", handleUnload);
    return () => {
      window.removeEventListener("beforeunload", handleUnload);
      document.removeEventListener("visibilitychange", handleUnload);
    };
  }, []);

  useEffect(() => {
    if (isSaving?.collection || isSaving?.digital || isSaving?.conservation) {
      const handleBeforeUnload = (e) => {
        e.preventDefault();
        e.returnValue = ""; // Required for showing browser's confirmation popup
      };

      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, [isSaving]);

  useEffect(() => {
    if (s3loading) {
      const handleBeforeUnload = (e) => {
        e.preventDefault();
        e.returnValue = ""; // Required for showing browser's confirmation popup
      };

      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, [s3loading]);

  return (
    <div>
      <MenuProvider>
        <GlobalLoadProvider>
          <ObjectEditProvider>
            <GlobalreleaseProvider>
              <GlobalIsReadProvider>
                <BrowserRouter>
                  <Toaster
                    position="top-center"
                    toastOptions={{ duration: 2000 }}
                  />

                  <Routes>
                    <Route path="/*" element={<PrivateRoutes />} />
                    {/* {routesToRender} */}
                    <Route exact path={LOGIN} element={<Login />} />
                    <Route
                      exact
                      path={FORGOT_PASSWORD}
                      element={<ForgotPassword />}
                    />
                    <Route
                      exact
                      path={NEW_PASSWORD}
                      element={<NewPassword />}
                    />
                    {/* <Route exact path={CURRENT_PASSWORD} element={<CurrentPassword />} /> */}
                    {/* <Route exact path={CURRENT_PASSWORD} element={<CurrentPassword />} /> */}
                    {/* <Route exact path={BRANCH_SELECT} element={<Branch />} /> */}
                  </Routes>
                </BrowserRouter>
              </GlobalIsReadProvider>
            </GlobalreleaseProvider>
          </ObjectEditProvider>
        </GlobalLoadProvider>
      </MenuProvider>

      {notification && (
        <PushNotification
          title={notification?.title}
          body={notification?.body}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
}

export default App;
